import { render } from "./About.vue?vue&type=template&id=142e4a5e"
import script from "./../js/About.js?vue&type=script&lang=js"
export * from "./../js/About.js?vue&type=script&lang=js"

import exportComponent from "C:\\Workspace\\Web App Service\\Screen Cast Web View\\Dev\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__